/**
 * Order Details
 */

// React
import React, { useContext, useEffect, useState } from 'react'

// Context
import AuthContext from '../../authContext'

// Redux
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Store } from '../../redux/reducers'
import {
  clearOrderAction,
  getAllOrderItemsAction,
  getCatAction,
  getLogsAction,
  getOrderWithIdAction,
  updateOrderStatusActions
} from '../orders/actions'

// Selector
import { createStructuredSelector } from 'reselect'
import {
  makeSelectAllOrderItems,
  makeSelectCatList,
  makeSelectError,
  makeSelectLoading,
  makeSelectLogs,
  makeSelectOrder
} from '../orders/selectors'

//UI
import theme from '../../theme'
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  Divider
} from '@material-ui/core'

import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator
} from '@material-ui/lab'

// Components
import ListOrderItems from './list'
import InventoryItemsList from './inventoryItemsList'
import Can from '../../components/Can'
import showOrderTplType from '../../utils/temporaryConditions/showOrderTplType'
import StaticMap from '../../components/maps/staticMap'
import DeliveryReceipt from './deliveryReceipt'

// Helper
import {
  formaterPhoneNumber,
  numberWithCommas,
  translate
} from '../../utils/helpers'
import jMoment from 'moment-jalaali'

// Type
import { Log } from '../orders/interfaces'
import { Props, SelectorProps } from './interfaces'
import CSV from './csv'
import { getInventoryItemsWithSerialAction } from '../parcels/actions'
import { makeSelectInventoryItemsWithSerialList } from '../parcels/selectors'
import handleError from '../../utils/handleError'
import Modal from '../../components/Modal'
import classes from './index.module.scss'
import { Link, useHistory } from 'react-router-dom'
import ordersRepository from 'client-sdk/src/Repository/orders-repository'
import getOrderFileReq from 'client-sdk/src/orders/files'
import showDeliveryType from '../../utils/temporaryConditions/showDeliveryType'
import RonadIcons from '../../components/iconComponent'
import CreateTicket from '../ticketing/components/registerTicket'
import { getAllTicket } from '../../api/ticket/get'

const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته‌بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main //'بازگردانده شده',
}

const iconStatus = {
  ARRIVED: 'mapMarker', //'به مقصد رسیده',
  BUNDLED: 'packageVariantClosed', //' بسته‌بندی شده برای راننده',
  CANCELLED: 'times', //'لغو شده',
  DELIVERED_TO_POST: 'circleMedium', //'ارسال شده',
  DELIVERED_TO_CENTER: 'circleMedium', //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: 'circleMedium', //'تامین در مرکز',
  PACKAGED: 'cubeOutline', //'بسته‌بندی شده برای مشتری',
  DELIVERED: 'listCheck', //'تحویل داده شده',
  LOADED: 'truck', // 'در حال تحویل',
  NOT_DELIVERED: 'information', //'تحویل داده نشده',
  ORDERED: 'circleMedium', //'ایجاد شده',
  RETURNED: 'undo', //'بازگردانده شده',
  PICKED: 'plusMultiple', //'برداشته شده',
  ASSIGNED: 'userArrowRight', //'برداشته شده',
  DELIVERING_TO_POST: 'circleMedium',
  DELIVERED_TO_COURIER: 'circleMedium',
  PROCESSING: 'circleMedium',
  PROCESSED: 'circleMedium',
  REGISTERED_IN_3PL: 'circleMedium',
  REGISTERING_IN_3PL: 'circleMedium',
  DELIVERING: 'circleMedium',
  DELIVERED_TO_3PL: 'circleMedium',
  DELIVERED_TO_3PL_COURIER: 'circleMedium',
  CANCELED_FROM_3PL: 'circleMedium',
  AWAITING_REVIEW: 'circleMedium',
  SUPPLYING: 'circleMedium',
  REQUESTED_TO_RETURN: 'circleMedium',
  RETURNED_TO_WAREHOUSE: 'circleMedium',
  REQUESTED_TO_RESEND: 'circleMedium',
  SCANNED: 'circleMedium',
  CONFIRMED: 'circleMedium',
  REGISTERED: 'circleMedium',
  AWAITING_PAYMENT: 'circleMedium',
  CANCELED: 'times'
}

export function Details(props: Props) {
  const history = useHistory()
  const authContext = useContext(AuthContext)
  const [isTapin, setIsTapin] = useState<boolean>(false)
  const [tapinBarcode, setTapinBarcode] = useState<number | undefined>()
  const [openInventoryItems, setOpenInventoryItems] = useState(false as boolean)
  const [oldTicket, setOldTicket] = useState([])
  const [openMsg, setOpenMsg] = useState(false)
  const [hasFileReceipt, setHasFileReceipt] = useState(false)

  useEffect(() => {
    getOldTicket(props.match.params.id)
  }, [])

  const getOldTicket = async (id: number) => {
    try {
      const res = await getAllTicket({ linkType: 'order', linkId: id })
      setOldTicket(res.data.content)
    } catch (error) {
      handleError(error)
    }
  }

  const getTapinBarcode = async (id) => {
    try {
      const response = await ordersRepository.getOrderTapinBarcode({
        payload: {
          ids: id
        }
      })
      const myResponse = response.data.barcodes[0]?.barcode[0]
      if (myResponse) {
        setTapinBarcode(myResponse)
        setIsTapin(true)
      }
    } catch (error) {
      handleError(error)
    }
  }

  const handleCloseModal = () => {
    setOpenMsg(false)
  }

  const handleShowInventoryItems = (data: any) => {
    props.getInventoryItems({
      orderItemId: { equals: data.id },
      size: 1000,
      page: 0,
      callback: () => setOpenInventoryItems(true)
    })
  }

  useEffect(() => {
    const { id } = props.match.params
    getTapinBarcode(id)
    props.orderWithIdActionDispatch(id)
    props.getOrderItemsActionDispatch({
      'orderId.equals': id,
      page: 0,
      size: 1000
    })
  }, [])

  useEffect(() => {
    props.getLogsDispatch(props.match.params.id)
  }, [props.order])

  useEffect(() => {
    return () => {
      props.clearOrderActionDispatch()
    }
  }, [])

  const getOrderFile = async (type: string) => {
    try {
      const response = await getOrderFileReq(props.order.id, { fileType: type })
      const file = URL.createObjectURL(response.blob)
      return file
    } catch (error: any) {
      console.log(error)
      handleError(error)
    }
  }

  const downLoadFile = async (type: string, fileName: string) => {
    try {
      const file = await getOrderFile(type)
      const link = document.createElement('a')
      link.href = file
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } catch (error: any) {
      handleError(error)
    }
  }
  const handlerTPL = (tpl: any) => {
    return tpl?.replace(/[\[\]]/g, '')
  }

  useEffect(() => {
    if (props.order?.files?.length > 0) {
      const res = props.order.files.filter(
        (item: any) => item.fileType === 'ORDER_DELIVERY_RECEIPT'
      )
      if (res.length > 0) setHasFileReceipt(true)
    }
  }, [props.order])

  return (
    <div className={classes.root}>
      <Typography variant='h6' component='h1' style={{ marginBottom: '24px' }}>
        <Button onClick={() => history.goBack()}>
          <RonadIcons name='chevronRight' />
        </Button>
        {`جزئیات سفارش ${props.match.params.id}`}
      </Typography>
      <Grid
        container
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: '32px' }}
      >
        <Grid item lg={3} md={3} sm={12} xs={12}>
          {props.order?.deliveryType === 'COURIER' &&
            props.order?.orderTPLType === 'CHAPAR' && (
              <Card className={classes.card}>
                <CardHeader
                  avatar={
                    <Typography className={classes.typographyCards}>
                      مشخصات مرسوله چاپار
                    </Typography>
                  }
                />
                <CardContent style={{ paddingBottom: '10px' }}>
                  <Grid xs={12} sm={12} lg={12} spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <div className={classes.item}>
                        <span className={classes.label}>
                          {'کد رهگیری چاپار:  '}
                        </span>
                        {handlerTPL(props.order?.tplTrackingCode)}
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}
          {isTapin && (
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    مشخصات مرسوله پستی
                  </Typography>
                }
              />

              <CardContent style={{ paddingBottom: '10px' }}>
                <Grid item xs={12} sm={12} spacing={2}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'کد رهگیری پست:  '}</span>

                    <a
                      target='_blank'
                      href={`https://tracking.post.ir/search.aspx?id=${tapinBarcode}`}
                    >
                      <span data-cy='trackingCode'>{tapinBarcode}</span>
                    </a>
                  </div>
                </Grid>
              </CardContent>
            </Card>
          )}
          {props.order?.deliveryType !== 'COURIER' && (
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    مشخصات مرسوله پستی
                  </Typography>
                }
              />
              <CardContent style={{ paddingBottom: '10px' }}>
                <Grid xs={12} sm={12} lg={12} spacing={2}>
                  {props.order?.postOrders?.map((order, index) => {
                    return (
                      <>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span style={{ fontSize: '18px' }}>
                              بسته {index + 1}
                            </span>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <div className={classes.item}>
                            <span className={classes.label}>
                              {'وضعیت مرسوله:  '}
                            </span>
                            <span data-cy={'orderStatus' + index}>
                              {translate(order.orderStatus, 'order')}
                            </span>
                          </div>
                        </Grid>

                        {order.barcode && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'کد رهگیری پست:  '}
                              </span>
                              <a
                                href={`https://tracking.post.ir/search.aspx?id=${order.barcode}`}
                                target='_blank'
                              >
                                <span data-cy={'barcode' + index}>
                                  {order.barcode}
                                </span>
                              </a>
                            </div>
                          </Grid>
                        )}
                        {order.weight && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'وزن پستی (گرم):  '}
                              </span>
                              <span data-cy={'orderWeight' + index}>
                                {order.weight}
                              </span>
                            </div>
                          </Grid>
                        )}
                        {order.totalPrice && (
                          <Grid item xs={12} sm={12}>
                            <div className={classes.item}>
                              <span className={classes.label}>
                                {'هزینه پست (ریال):  '}
                              </span>
                              <span data-cy='totalPrice'>
                                {order.totalPrice}
                              </span>
                            </div>
                          </Grid>
                        )}
                      </>
                    )
                  })}
                </Grid>
              </CardContent>
            </Card>
          )}
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات سفارش
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نوع پردازش:'}</span>
                  <span style={{ textAlign: 'left' }} data-cy='status'>
                    {props.order?.fulfillmentTypeName}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'خدمات تحویل:'}</span>

                  <span>{props.order?.deliveryServiceName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نوع ناوگان:'}</span>

                  <span>{props.order?.courierName}</span>
                </div>
              </Grid>
              <Divider />
              <Grid
                style={{ marginTop: '24px' }}
                item
                xs={12}
                sm={12}
                lg={12}
                spacing={2}
              >
                <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت تحویل:  '}</span>
                  <span style={{ textAlign: 'left' }} data-cy='status'>
                    {translate(props.order.status, 'order')}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شیوه پرداخت :  '}</span>

                  <span>{translate(props.order.paymentType, 'cod')}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'شیوه پرداخت کرایه:  '}
                  </span>

                  <span>{props.order.postPaid && 'پس کرایه'}</span>
                </div>
              </Grid>
              {props.order?.paymentType === 'COD' && (
                <Grid item xs={12} sm={12} lg={12} spacing={2}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'مبلغ فاکتور:  '}</span>

                    <span>{numberWithCommas(props.order.codValue)}</span>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کدپیگیری:  '}</span>
                  <span data-cy='trackingCode'>
                    {props.order?.trackingCode}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'تعداد بسته:  '}</span>
                  <span data-cy='trackingCode'>
                    {props.order?.orderPackages?.length}
                  </span>
                </div>
              </Grid>
              {props.order.orderType === 'FROM_CENTER' && (
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'محل تحویل سفارش:'}</span>
                    <span data-cy='deliveryType'>
                      {translate(props.order.centerName)}
                    </span>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' تاریخ ثبت سفارش:  '}</span>
                  <span data-cy='registrationDate'>
                    {props.order.registrationDate &&
                      `${jMoment(props.order.registrationDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'تاریخ تحویل سفارش:  '}
                  </span>
                  <span data-cy='deliveryDate'>
                    {props.order.deliveryDate &&
                      `${jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {' بازه تحویل سفارش:  '}
                  </span>
                  <span data-cy='deliveryStartTime'>
                    {props.order.deliveryStartTime &&
                      jMoment(props.order.deliveryStartTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                    {' - '}
                    {props.order.deliveryEndTime &&
                      jMoment(props.order.deliveryEndTime, 'hh:mm:ss')
                        .locale('fa')
                        .format('HH:mm')}
                  </span>
                </div>
              </Grid>
              {props.order.description && (
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'توضیحات:  '}</span>
                    <span data-cy='description'>
                      {props.order.description && props.order.description}
                    </span>
                  </div>
                </Grid>
              )}
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات ارسال
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              {props.order?.senderName && (
                <Grid xs={12} sm={12} lg={12} spacing={2}>
                  <div className={classes.item}>
                    <span className={classes.label}>{'نام فرستنده:'}</span>
                    <span data-cy='customerName'>
                      {props.order?.senderName}
                    </span>
                  </div>
                </Grid>
              )}
              <Grid xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام گیرنده:'}</span>

                  <span data-cy='customerName'>{props.order.customerName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'کد ملی:'}</span>
                  <span data-cy='customerNationalCode'>
                    {props.order?.customerNationalCode}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' شماره ثابت:     '}</span>
                  <span dir='ltr' data-cy='customerPhoneNumber'>
                    {props.order?.customerPhoneNumber}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره همراه:  '}</span>
                  <span data-cy='customerMobileNumber'>
                    {formaterPhoneNumber(props.order.customerMobileNumber)}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{' کد پستی:    '}</span>
                  <span data-cy='customerZipCode'>
                    {props.order?.customerZipCode}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شهر:  '}</span>

                  <span data-cy='customerCity'>
                    {props.order?.customerCity}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'استان:  '}</span>

                  <span data-cy='customerProvince'>
                    {props.order?.customerProvince}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.item}>
                  <span
                    className={classes.label}
                    style={{ alignSelf: 'start' }}
                  >
                    {'آدرس:  '}
                  </span>
                  <span
                    style={{ textAlign: 'left', marginRight: '30px' }}
                    data-cy='customerAddress'
                  >
                    {props.order.customerAddress && props.order.customerAddress}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
          {hasFileReceipt && <DeliveryReceipt orderId={props.order.id} />}
          {props.order.customerLat && (
            <Grid item xs={12}>
              <StaticMap
                style={{
                  height: '350px',
                  position: 'relative',
                  zIndex: 1
                }}
                zoom={14}
                center={{
                  lat: props.order.customerLat,
                  lon: props.order.customerLon
                }}
                position={{
                  lat: props.order.customerLat,
                  lon: props.order.customerLon
                }}
                draggable={false}
              />
            </Grid>
          )}
        </Grid>
        <Grid item lg={9} md={9} sm={12} xs={12} spacing={2}>
          <Card className={classes.card} style={{ padding: 0 }}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  لیست کالاهای سفارش {props.order.id}
                </Typography>
              }
              action={
                <Grid item xs={12} style={{ marginTop: '15px' }}>
                  <div style={{ textAlign: 'left', marginBottom: '-20px' }}>
                    <Can
                      role={authContext.user.role}
                      perform='orders:downloadReportCSV'
                      yes={() => (
                        <>
                          <CSV
                            // ordersDispatch={props.order}
                            data={props.orderItems}
                            loading={props.loading}
                          />
                        </>
                      )}
                    />
                    {oldTicket.length === 0 ? (
                      <Button
                        variant='contained'
                        size='large'
                        color='primary'
                        style={{ marginLeft: '12px' }}
                        onClick={() => setOpenMsg(true)}
                      >
                        {`تیکت جدید`}
                      </Button>
                    ) : (
                      <Link to={`/tickets/${oldTicket[0].id}`}>
                        <Button
                          style={{ marginLeft: '12px' }}
                          variant='contained'
                          size='large'
                          color='primary'
                          // style={{ marginLeft: '172px' }}
                        >
                          {`سابقه تیکت`}
                        </Button>
                      </Link>
                    )}
                    {props.order.orderType === 'FROM_CENTER' && (
                      <Can
                        perform='orderExit:print'
                        role={authContext.user.role}
                        yes={() => (
                          <Link
                            to={`/orders/exit-receipts/${props.order.id}`}
                            target='_blank'
                            style={{
                              textDecoration: 'none',
                              margin: '0px 10px'
                            }}
                          >
                            <Button
                              variant='contained'
                              color='secondary'
                              startIcon={<RonadIcons name='receipt' size={1} />}
                            >
                              {'چاپ رسید خروج'}
                            </Button>
                          </Link>
                        )}
                      />
                    )}
                    {props.order.receiptUrl &&
                      props.order?.status !== 'CANCELLED' && (
                        <a
                          href={`${props.order.receiptUrl}`}
                          target='_blank'
                          style={{ textDecoration: 'none', marginLeft: '10px' }}
                        >
                          <Button
                            variant='contained'
                            color='secondary'
                            startIcon={
                              <RonadIcons
                                name='printer'
                                className='text-white'
                                size={1}
                              />
                            }
                          >
                            {'چاپ فاکتور سفارش'}
                          </Button>
                        </a>
                      )}
                    {props.order.fulfillmentAttachmentUrl &&
                      props.order?.status !== 'CANCELLED' && (
                        <a
                          href={`${props.order.fulfillmentAttachmentUrl}`}
                          target='_blank'
                          style={{ textDecoration: 'none' }}
                        >
                          <Button
                            variant='contained'
                            color='secondary'
                            startIcon={
                              <RonadIcons
                                name='lable'
                                className='text-white'
                                size={1}
                              />
                            }
                          >
                            {'چاپ لیبل های سفارش'}
                          </Button>
                        </a>
                      )}
                    {props.order.receiptFileName &&
                      props.order?.status !== 'CANCELLED' && (
                        <Button
                          variant='contained'
                          color='primary'
                          size='large'
                          style={{ marginLeft: '12px' }}
                          startIcon={
                            <RonadIcons
                              name='printer'
                              className='text-white'
                              size={1}
                            />
                          }
                          onClick={() =>
                            downLoadFile('RECEIPT', props.order.receiptFileName)
                          }
                        >
                          دانلود فایل فاکتور
                        </Button>
                      )}
                    {props.order.labelFileName &&
                      props.order?.status !== 'CANCELLED' && (
                        <Button
                          variant='contained'
                          color='primary'
                          size='large'
                          startIcon={
                            <RonadIcons
                              name='lable'
                              className='text-white'
                              size={1}
                            />
                          }
                          onClick={() =>
                            downLoadFile('LABEL', props.order.labelFileName)
                          }
                        >
                          دانلود فایل لیبل
                        </Button>
                      )}
                  </div>
                </Grid>
              }
            />

            <CardContent
              style={{ margin: '14px 0  0', padding: '0' }}
              className={classes.cardContentList}
            >
              <Grid
                style={{ width: '100%', margin: '0' }}
                container
                spacing={3}
              >
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : props.order.childOrders?.length > 0 ? (
                  props.order.childOrders.map((childOrder, index) => {
                    return (
                      <React.Fragment>
                        <div>
                          {`لیست کالاهای ${childOrder.fulfillmentWarehouseName}`}
                        </div>
                        <ListOrderItems
                          data={childOrder.items}
                          showItems={(data) => handleShowInventoryItems(data)}
                        />
                      </React.Fragment>
                    )
                  })
                ) : (
                  props.order?.items && (
                    <>
                      <ListOrderItems
                        data={props.order?.items}
                        showItems={(data) => handleShowInventoryItems(data)}
                      />
                    </>
                  )
                )}
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card} style={{ marginTop: '24px' }}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  تاریخچه سفارش
                </Typography>
              }
            />
            <CardContent style={{ padding: '0', marginTop: '-10px' }}>
              <Grid container style={{ padding: '0' }}>
                <Grid item xs={12}>
                  <Timeline align='left' style={{ minWidth: '500px' }}>
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          className={classes.missingOppositeContent}
                          key={index}
                          data-cy='timeLineItem'
                        >
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? 'solid 4px #DF9234' : ''
                              }}
                            >
                              <RonadIcons
                                name={iconStatus[log.newStatus]}
                                size={1}
                                className='text-white'
                              />
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ''
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div style={{ padding: '10px' }}>
                              <div className={classes.contentBox}>
                                <div style={{ flex: 2, textAlign: 'right' }}>
                                  <span className={classes.contentlabel}>
                                    وضعیت سفارش:
                                  </span>
                                  <span data-cy='status'>
                                    {translate(log.newStatus, 'order')}
                                  </span>
                                  {log.newStatus === 'NOT_DELIVERED' && (
                                    <p data-cy='status'>{log.description}</p>
                                  )}
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: 'right',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <span className={classes.contentlabel}>
                                    کاربر:
                                  </span>
                                  <Can
                                    role={authContext.user.role}
                                    perform='user-name:dontShowInLogs'
                                    no={() => (
                                      <>
                                        <span>{log.modifierName}</span>
                                        <span>
                                          {' '}
                                          &nbsp; &nbsp;- &nbsp; &nbsp;
                                        </span>
                                      </>
                                    )}
                                  />
                                  <span data-cy='role'>
                                    {translate(log.modifierRole, 'user')}
                                  </span>
                                </div>
                                <Typography
                                  component='div'
                                  className={classes.titleBox}
                                  style={{ flex: 1 }}
                                >
                                  {log.time &&
                                    jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                      .locale('fa')
                                      .format('jYYYY/jMM/jDD - HH:mm')}
                                </Typography>
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby='responsive-dialog-title'
        maxWidth='sm'
        fullWidth
        style={{ padding: '16px' }}
      >
        <DialogTitle>
          <Grid container justifyContent='center' justify='center'>
            <p style={{ marginTop: '-8px' }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction='column'>
          <CreateTicket
            handleCloseModal={handleCloseModal}
            linkType='order'
            linkId={props.match.params.id}
          />
        </Grid>
      </Dialog>
      <Modal
        onClose={() => setOpenInventoryItems(false)}
        maxWidth='md'
        open={openInventoryItems}
        title={
          <div className={classes.addIcon}>
            <RonadIcons name='store' size={4} className='text-green' />
          </div>
        }
        content={<InventoryItemsList data={props.inventoryItems} />}
      />
    </div>
  )
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  catList: makeSelectCatList(),
  order: makeSelectOrder(),
  orderItems: makeSelectAllOrderItems(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsWithSerialList()
})

function mapDispatchToProps(dispatch: Function) {
  return {
    getCatDispatch: (payload: any) => dispatch(getCatAction(payload)),
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    updateOrderStatusDispatch: (payload: {
      id: number
      body: string
      pagination: object
      callback?: () => void
    }) => dispatch(updateOrderStatusActions(payload)),
    clearOrderActionDispatch: () => dispatch(clearOrderAction()),
    getInventoryItems: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
    getOrderItemsActionDispatch: (payload: any) =>
      dispatch(getAllOrderItemsAction(payload))
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
export default compose(withConnect)(Details)
